import React from 'react';

export default function Mission() {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-12">Our Mission</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Tailored Solutions */}
          <div className="text-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-16 w-16 text-indigo-600 mx-auto mb-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 11V3m0 18v-8m9 3a9 9 0 10-18 0 9 9 0 0018 0z" />
            </svg>
            <h3 className="text-xl font-semibold mb-2">Tailored Solutions</h3>
            <p className="text-gray-600">We provide customized real estate solutions that meet diverse client needs.</p>
          </div>
          {/* Community Growth */}
          <div className="text-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-16 w-16 text-indigo-600 mx-auto mb-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M17 20h5v-2a4 4 0 00-5-3.87M9 20H4v-2a4 4 0 015-3.87M12 12a4 4 0 100-8 4 4 0 000 8zm0 4v8m8-8H4"
              />
            </svg>
            <h3 className="text-xl font-semibold mb-2">Community Growth</h3>
            <p className="text-gray-600">We develop properties that enhance communities and drive economic growth.</p>
          </div>
          {/* Expansive Opportunities */}
          <div className="text-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-16 w-16 text-indigo-600 mx-auto mb-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M21 12.79A8 8 0 1111.21 3H12a9 9 0 109 9v-.21zm-9 0a9.05 9.05 0 000 8.43"
              />
            </svg>
            <h3 className="text-xl font-semibold mb-2">Expansive Opportunities</h3>
            <p className="text-gray-600">Our reach extends across cities and regions, unlocking endless possibilities for property investment and development.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
